import React from 'react'
import LogoCircle from '@images/img_logo_cicle.png'
import * as hs from './DownloadNav.module.scss'

function DownloadNav() {
  return (
    <div className={hs.footBottom}>
      <a target='_blank' rel='nofollow' href="https://yourls.bybieyang.com/h5opa" id={hs.downloadBar}>
        <div className={hs.bd}>
          <img src={LogoCircle} className={hs.logo} alt="logo" />
          <div className={hs.detail}>
            <div className={hs.bigger}>
              <span>别样海外购APP</span>
              <span className={hs.red}>
              <span className={hs.colorRed}>688元</span>新人大礼包</span>
            </div>
            <div className={hs.footBottomDesc}>直播美国折扣·官网同价直送·支付宝一键支付</div>
          </div>
        </div>
        <div className={hs.ft}>下载APP</div>
      </a>
    </div>
  )
}

export default DownloadNav
